import Blue from "~/core";

new Blue({
  name: "Interior Video Rail Modal",
  selector: ".interior-video",
  setup(interiorVideoRail) {
    let videoDialog = interiorVideoRail.querySelector("dialog");
    let modalTrigger = interiorVideoRail.querySelector(".interior-video__trigger");
    let modalClose = interiorVideoRail.querySelector(".interior-video__dialog-close");
    this.$addEvents(modalTrigger, 'click', function () {
      videoDialog.showModal();
    });
    this.$addEvents(modalClose, 'click', function () {
      resetVideoSource();

      videoDialog.close();
    });
    videoDialog.addEventListener('click', function(event) {
      var rect = videoDialog.getBoundingClientRect();
      var isInDialog = (rect.top <= event.clientY && event.clientY <= rect.top + rect.height &&
        rect.left <= event.clientX && event.clientX <= rect.left + rect.width);
        
      if (!isInDialog) {
        resetVideoSource();

        videoDialog.close();
      }
    });

        /**
     * Resets the source of the video iframe to pause the video.
     * This function selects the iframe within the video dialog and reassigns its source URL to itself,
     * effectively pausing the video.
     */
        function resetVideoSource() {
          let iframe = videoDialog.querySelector("iframe");
    
          if (iframe) {
            let iframeSrc = iframe.src;
            iframe.src = iframeSrc;
          }
        }
  }
});